import { useEffect, useState } from "react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Textarea } from "./ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "./ui/dialog";
import { toast } from "sonner";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function EnquiryModal({ open, onOpenChange, project }) {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (open) setForm({ name: "", email: "", phone: "", message: "" });
  }, [open]);

  const submit = async (e) => {
    e.preventDefault();
    if (!project) return;
    setBusy(true);
    try {
      await axios.post(`${API}/enquiries`, {
        project_id: project.id,
        name: form.name.trim(),
        email: form.email.trim(),
        phone: form.phone.trim() || undefined,
        message: form.message.trim(),
      });
      toast.success("Enquiry sent — the manager will reach out shortly.");
      onOpenChange(false);
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Could not send enquiry. Please try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="enquiry-modal">
        <DialogHeader>
          <DialogTitle>Enquire about {project?.name || "this project"}</DialogTitle>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <div>
            <Label htmlFor="enq-name">Your name</Label>
            <Input id="enq-name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="enquiry-name-input" />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <Label htmlFor="enq-email">Email</Label>
              <Input id="enq-email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="enquiry-email-input" />
            </div>
            <div>
              <Label htmlFor="enq-phone">Phone</Label>
              <Input id="enq-phone" type="tel" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} data-testid="enquiry-phone-input" />
            </div>
          </div>
          <div>
            <Label htmlFor="enq-msg">What would you like to know?</Label>
            <Textarea id="enq-msg" rows={4} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} placeholder="Plot size, cottage design, water source, expected yield…" data-testid="enquiry-message-input" />
          </div>
          <p className="text-[11px] text-muted-foreground">By submitting, you agree to be contacted about {project?.name}. Your details are sent only to the estate manager.</p>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
            <Button type="submit" disabled={busy || !form.name || !form.email} data-testid="enquiry-submit-btn">
              {busy ? "Sending…" : "Send enquiry"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
